import React from "react";
import "./footer.scss";
//import Logo_fb from "../../../assets/icons/ico-facebook.png";
//import Logo_ig from "../../../assets/icons/ico-ins.png";
//import Logo_yt from "../../../assets/icons/ico-youtube.png";
//import Logo_tw from "../../../assets/icons/ico-twitter.png";
//import img_govco from "../../../assets/icons/img-govco.svg";
//import logo_cocolombia from "../../../assets/icons/logo-cocolombia.png";
//import logo_SIC from "../../../assets/icons/logo-sic-footer.png";
//import logo_GPTW from "../../../assets/icons/logo-certificado-footer.png";
//import ico_telefono from '../../../assets/icons/ico-telefono.svg'
//import ico_correo from '../../../assets/icons/ico-correo.svg'
// import { useSelector } from 'react-redux';
// import { getFooterStatus } from '../../store/selectors';

export default function Footer(props) {
  // const footerState = useSelector(getFooterStatus);

  return (
    <>
      <footer className="bodygovcobase">
        <div className="govcobasefooter">
          <div className="govcobasefooter__container">
            <div className="govcobasefooter__content">
              <div className="govcobasefooter_content_info">
                <div className="govcobasefooter_contentinfo_head">
                  <div className="govcobasefooter_contentinfohead_name">
                    <h2 className="govcobasefooter_contentinfoheadname_titulo">
                      Superintendencia de Industria y Comercio
                    </h2>
                  </div>
                  <div className="govcobasefooter_contentinfohead_logo">
                    <img
                      className="govcobasefooter_contentinfoheadlogo_img"
                      alt="Logo Sic"
                      data-entity-type="file"
                      data-entity-uuid="0a8765c2-ebc1-4f90-93a4-fc6043b38ae1"
                      height="auto"
                      src="https://stgsicstatic.z13.web.core.windows.net/src/Logos-Gobierno/Logo_Comercio.png"
                      width="250"
                    />
                  </div>
                </div>
                <div className="govcobasefooter_contentinfo_sede">
                  <h3 className="govcobasefooter_contentinfosede_texto">
                    Sede Principal
                  </h3>
                </div>
                <div className="govcobasefooter_contentinfo_contact">
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Dirección: Carrera 13 No. 27 - 00, Pisos 1 y 3
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Código postal: 110311
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Horario de atención: Lunes a Viernes de 8:00 am a 4:30 pm
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Teléfono conmutador: +57 601 587 0000 - Bogotá
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Línea de atención: +57 601 592 0400 - Bogotá
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Línea Gratuita Nacional: 01 8000 910165
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Línea anticorrupción: +57 601 587 0000 - Bogotá
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Correo institucional:{" "}
                    <a href="mailto:contactenos@sic.gov.co">
                      contactenos@sic.gov.co
                    </a>
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Notificaciones judiciales:
                    <a href="mailto:notificacionesjud@sic.gov.co">
                      notificacionesjud@sic.gov.co
                    </a>
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Denunciar actos de corrupción:
                    <a
                      href="https://servicioslinea.sic.gov.co/servilinea/ServiLinea/DenunciaCorrupcion/control/DenunciaCorrupcion.php"
                      target="_blank"
                    >
                      Ingresa a nuestra aplicación de denuncias por corrupción
                    </a>
                  </p>
                </div>
                <div className="govcobasefooter_contentinfo_network">
                  <a
                    className="govcobasefooter_contentinfo_network-link"
                    href="https://www.facebook.com/Superintendenciadeindustriaycomercio/"
                    target="_blank"
                  >
                    <svg
                      className="govcobasefooter--svg-redes"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <rect width="24" height="24" rx="2" fill="#3366CC" />
                      <path
                        d="M15.441 12.8437L15.8517 10.1399H13.2838V8.38533C13.2838 7.64562 13.6426 6.92459 14.7926 6.92459H15.96V4.62261C15.96 4.62261 14.9007 4.43994 13.8878 4.43994C11.773 4.43994 10.3907 5.73494 10.3907 8.07923V10.1399H8.04004V12.8437H10.3907V19.3799H13.2838V12.8437H15.441Z"
                        fill="white"
                      />
                    </svg>
                    @Superintendenciadeindustriaycomercio
                  </a>
                  <a
                    className="govcobasefooter_contentinfo_network-link"
                    href="https://www.youtube.com/channel/UC2-SvnOPldLjx4QT7HTCoyw"
                    target="_blank"
                  >
                    <svg
                      className="govcobasefooter--svg-redes"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="2"
                        fill="#3366CC"
                      />
                      <path
                        d="M11.9117 8.94868C9.99621 8.94868 8.4512 10.494 8.4512 12.4099C8.4512 14.3258 9.99621 15.8711 11.9117 15.8711C13.8271 15.8711 15.3721 14.3258 15.3721 12.4099C15.3721 10.494 13.8271 8.94868 11.9117 8.94868ZM11.9117 14.6602C10.6738 14.6602 9.66191 13.651 9.66191 12.4099C9.66191 11.1688 10.6708 10.1597 11.9117 10.1597C13.1525 10.1597 14.1614 11.1688 14.1614 12.4099C14.1614 13.651 13.1495 14.6602 11.9117 14.6602ZM16.3208 8.8071C16.3208 9.25595 15.9594 9.61442 15.5137 9.61442C15.0649 9.61442 14.7065 9.25293 14.7065 8.8071C14.7065 8.36127 15.0679 7.99978 15.5137 7.99978C15.9594 7.99978 16.3208 8.36127 16.3208 8.8071ZM18.6127 9.62647C18.5615 8.54502 18.3146 7.58708 17.5225 6.79784C16.7334 6.0086 15.7757 5.76158 14.6945 5.70736C13.5802 5.6441 10.2402 5.6441 9.12583 5.70736C8.04764 5.75857 7.08991 6.00558 6.29783 6.79483C5.50575 7.58407 5.2618 8.54201 5.20759 9.62346C5.14434 10.738 5.14434 14.0788 5.20759 15.1934C5.25879 16.2748 5.50575 17.2327 6.29783 18.022C7.08991 18.8112 8.04462 19.0582 9.12583 19.1125C10.2402 19.1757 13.5802 19.1757 14.6945 19.1125C15.7757 19.0613 16.7334 18.8142 17.5225 18.022C18.3116 17.2327 18.5585 16.2748 18.6127 15.1934C18.676 14.0788 18.676 10.7411 18.6127 9.62647ZM17.1731 16.3893C16.9382 16.9797 16.4834 17.4346 15.8901 17.6725C15.0017 18.025 12.8935 17.9437 11.9117 17.9437C10.9298 17.9437 8.81863 18.022 7.93319 17.6725C7.34289 17.4376 6.88813 16.9827 6.6502 16.3893C6.29783 15.5006 6.37915 13.3919 6.37915 12.4099C6.37915 11.4279 6.30084 9.31619 6.6502 8.43055C6.88511 7.84013 7.33988 7.38526 7.93319 7.14728C8.82165 6.79483 10.9298 6.87616 11.9117 6.87616C12.8935 6.87616 15.0047 6.79784 15.8901 7.14728C16.4804 7.38224 16.9352 7.83711 17.1731 8.43055C17.5255 9.31921 17.4442 11.4279 17.4442 12.4099C17.4442 13.3919 17.5255 15.5036 17.1731 16.3893Z"
                        fill="white"
                      />
                    </svg>
                    @superintendencia_sic
                  </a>
                  <a
                    className="govcobasefooter_contentinfo_network-link"
                    href="https://twitter.com/sicsuper"
                    target="_blank"
                  >
                    <svg
                      className="govcobasefooter--svg-redes"
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                    >
                      <rect width="25" height="25" rx="2" fill="#3366CC" />
                      <path
                        d="M5.03906 6L11.2162 14.2613L5 20.9752H6.39904L11.8416 15.0961L16.2402 20.9755H21L14.4749 12.251L20.2611 6H18.862L13.8499 11.4136L9.7998 6H5.03906ZM7.09659 7.03073H9.28378L18.9415 19.9444H16.755L7.09659 7.03073Z"
                        fill="white"
                      />
                    </svg>
                    @sicsuper
                  </a>

                  <a
                    className="govcobasefooter_contentinfo_network-link"
                    href="https://www.youtube.com/channel/UC2-SvnOPldLjx4QT7HTCoyw"
                    target="_blank"
                  >
                    <svg
                      className="govcobasefooter--svg-redes"
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                    >
                      <rect width="25" height="25" rx="2" fill="#3366CC" />
                      <path
                        d="M20.0682 9.41354C19.8964 8.77055 19.3902 8.26416 18.7474 8.0923C17.5823 7.78003 12.9104 7.78003 12.9104 7.78003C12.9104 7.78003 8.23858 7.78003 7.07347 8.0923C6.43069 8.26418 5.92444 8.77055 5.75262 9.41354C5.44043 10.579 5.44043 13.0106 5.44043 13.0106C5.44043 13.0106 5.44043 15.4422 5.75262 16.6076C5.92444 17.2506 6.43069 17.7359 7.07347 17.9078C8.23858 18.22 12.9104 18.22 12.9104 18.22C12.9104 18.22 17.5823 18.22 18.7474 17.9078C19.3902 17.7359 19.8964 17.2506 20.0682 16.6076C20.3804 15.4422 20.3804 13.0106 20.3804 13.0106C20.3804 13.0106 20.3804 10.579 20.0682 9.41354ZM11.3825 15.2183V10.8029L15.2872 13.0106L11.3825 15.2183Z"
                        fill="white"
                      />
                    </svg>
                    Super intendencia de industria y comercio
                  </a>
                  <a
                    className="govcobasefooter_contentinfo_network-link"
                    href="https://www.tiktok.com/@sicsuper"
                    target="_blank"
                  >
                    <svg
                      className="govcobasefooter--svg-redes"
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                    >
                      <rect width="25" height="25" rx="2" fill="#3366CC" />
                      <path
                        d="M14.125 4.00001L16.3532 4C16.514 4.80439 16.9607 5.81919 17.7419 6.82594C18.5074 7.8124 19.5218 8.50001 20.875 8.50001V10.75C18.9024 10.75 17.4202 9.83475 16.375 8.69282V16.375C16.375 19.4816 13.8566 22 10.75 22C7.6434 22 5.125 19.4816 5.125 16.375C5.125 13.2684 7.6434 10.75 10.75 10.75V13C8.88604 13 7.375 14.5111 7.375 16.375C7.375 18.239 8.88604 19.75 10.75 19.75C12.614 19.75 14.125 18.239 14.125 16.375V4.00001Z"
                        fill="white"
                      />
                    </svg>
                    @sicsuper
                  </a>
                </div>
                <div className="govcobasefooter_contentinfo_sede_bootom">
                  <h3 className="govcobasefooter_contentinfosede_texto">
                    Sede: Servicio de correspondencia y radicación
                  </h3>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Dirección: Av. Carrera 7 No. 31a - 36 pisos 3 - Bogotá
                  </p>
                  <p className="govcobasefooter_contentinfo_contact-line">
                    Horario de atención: Lunes a Viernes 8:00 am - 4:30 pm
                  </p>
                </div>
                <div className="govcobasefooter_contentinfo_policies">
                  <a
                    className="govcobasefooter_contentinfopolicies_link"
                    href="https://www.sic.gov.co/ley-de-proteccion-de-datos"
                  >
                    Políticas
                  </a>
                  <a
                    className="govcobasefooter_contentinfopolicies_link"
                    href="https://www.sic.gov.co/politica-privacidad"
                  >
                    Términos y condiciones
                  </a>
                  <a className="govcobasefooter_contentinfopolicies_link" 
                  href="https://sedeelectronica.sic.gov.co/transparencia/obligacion-de-reporte-de-informacion-especifica/accesibilidad">
                    Accesibilidad
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="govcobasefooter_content_bottombar">
            <div className="govcobasefooter_content_bottombar_maxwith">
              <div className="govcobasefooter_content_bottombar_maxwith--logos">
                <a href="https://www.colombia.co/">
                  <img
                    className="govcobasefooter_content_bottombar_maxwith--logos--img1colombia"
                    alt="logo pie"
                    src="https://cdn.www.gov.co/v3/assets/images/colombiaco_Mesa%20de%20trabajo%201.png"
                    width="48px"
                    height="48px"
                  />
                </a>
                <a
                  className="govcobasefooter_contentbottombar_link"
                  href="https://www.gov.co"
                >
                  <img
                    className="govcobasefooter_content_bottombar_maxwith--logos--img2govco"
                    alt="logo pie2"
                    src="https://cdn.www.gov.co/v3/assets/images/logo.svg"
                    height="48px"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
